import type { OrgArtifact } from '@onefootprint/request-types/dashboard';
import splitReportSections, { type SplitReport } from './split-report-sections';

/**
 * An agent's report split into its sections, or null for anything that reads as a plain document: one
 * someone started here, or a report with no sections to lay out.
 */
const reportCardsOf = (artifact: OrgArtifact | null, markdown: string | null | undefined): SplitReport | null => {
  if (artifact?.metadata.kind !== 'agent_graph_artifact' || artifact.mimeType !== 'text/markdown' || !markdown) {
    return null;
  }
  const report = splitReportSections(markdown);
  return report.sections.length > 0 ? report : null;
};

export default reportCardsOf;
